import { Person } from '@/shared/types'

export const getFullName = <T extends Person>(person: T): string => {
  const { firstname, lastname } = person
  if (firstname && lastname) return `${firstname} ${lastname}`
  if (firstname) return firstname
  if (lastname) return lastname
  return 'Unknown'
}
